<!--COMPONENTE QUE SELECCIONA DEPARTAMENTOS POR DIRECCION-->

<template>
  <div class="mr-5 box">
    <el-select
      v-if="onlyDepartment == false"
      v-model="directionId"
      filterable
      clearable
      size="mini"
      placeholder="Direccion"
      @change="handleChangeDirection"
      class="mr-5"
    >
      <el-option
        v-for="(item, index) in directions"
        :key="index"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-select>

    <el-select
      v-model="depSelected"
      filterable
      clearable
      size="mini"
      placeholder="Departamento"
      @change="hanldeSelection"
    >
      <el-option
        v-for="(item, index) in deparments"
        :key="index"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
import { formatArrayToElSelect } from "@/utils";

export default {
  name: "DepartmentSelector",
  props: {
    onlyDepartment: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  created() {
    this.loading = true;
    let url = "/api/Directions/DirectionsByCompany";

    if (this.onlyDepartment == true) url = "/api/Directions/GetAllDeparment";

    this.$http
      .get(url, {
        params: {
          company: this.currentCompany
        }
      })
      .then((response) => {
        if (this.onlyDepartment)
          this.deparments = formatArrayToElSelect(response.data);
        else this.directions = formatArrayToElSelect(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  data() {
    return {
      depSelected: "",
      dirSelected: "",
      deparments: [],
      directions: [],
      departmentId: null,
      directionId: null,
      loading: false
    };
  },
  methods: {
    getDepartaments() {
      this.$http
        .get("/api/Directions/DepartmentByDirecctionID", {
          params: {
            DirecctionId: this.directionId
          }
        })
        .then((response) => {
          this.deparments = formatArrayToElSelect(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    hanldeSelection() {
      if (this.depSelected) {
        this.$emit("selection-change", this.depSelected);
      } else {
        this.$emit("selection-change", null);
      }
    },
    handleChangeDirection(directionId) {
      this.directionId = directionId;
      this.depSelected = null;
      if (directionId) {
        this.getDepartaments();
        this.$emit("onDirectionChange", directionId);
      } else {
        this.$emit("onDirectionChange", null);
      }
    }
  }
};
</script>

<style></style>
